import { Utils } from "../../shared/utils";

export class ConceptConst {
  public static headerTable = [
    { field: 'name', title: 'Nombre', cell: (row) => `${row.name}`, class: (row) => `` },
    {
      field: 'description', title: 'Descripción', cell: (row) =>
        row.description ? `${row.description}` : '', class: (row) => ``
    },
    {
      field: 'units', title: 'Uds', cell: (row) => row.units ? `${row.units}` : '', class: (row) => ``
    },
    {
      field: 'categoryName', title: 'Familia', cell: (row) =>
        row.categoryName ? `${row.categoryName}` : '', class: (row) => ``
    },
    { field: 'price', title: 'Precio', cell: (row) => Utils.FormatMoney(row.price) + ' €', class: (row) => `` },
    { field: 'stockCostValue', title: 'Valor coste stock', cell: (row) => Utils.FormatMoney(row.units * row.costPrice) + ' €', class: (row) => `` },
    { field: 'salesValueStock', title: 'Valor venta stock', cell: (row) => Utils.FormatMoney(row.units * row.netPrice) + ' €', class: (row) => `` },
    { field: 'size', title: 'Talla', cell: (row) => row.size ? `${row.size}` : '', class: (row) => `` },
    { field: 'model', title: 'Modelo', cell: (row) => row.model ? `${row.model}` : '', class: (row) => `` },
    {
      field: 'serialNumber',
      title: 'Número de serie',
      cell: (row) => row.serialNumber ? '✅' : '❌', class: (row) => ``
    },
  ];

}

export class ConceptFamilyConst {
  public static headerTable = [
    { field: 'name', title: 'Nombre', cell: (row) => `${row.name}`, class: (row) => `` },
    {
      field: 'description', title: 'Descripción', cell: (row) =>
        row.description ? `${row.description}` : '', class: (row) => ``
    },
  ];
}

export class ConceptImportConst {
  public static headerTable = [
    { field: 'name', title: 'Nombre', cell: (row) => `${row.name}`, class: (row) => `` },
    { field: 'description', title: 'Descripción', cell: (row) => `${row.description}`, class: (row) => `` },
    { field: 'categoryName', title: 'Categoría', cell: (row) => `${row.categoryName}`, class: (row) => `` },
    { field: 'shortcut', title: 'Atajo teclado', cell: (row) => `${row.shortcut}`, class: (row) => `` },
    { field: 'costPrice', title: 'Precio costo', cell: (row) => Utils.FormatMoney(row.costPrice) + ' €', class: (row) => `` },
    { field: 'netPrice', title: 'Precio neto', cell: (row) => Utils.FormatMoney(row.netPrice) + ' €', class: (row) => `` },

    { field: 'barcode', title: 'Código de barras', cell: (row) => `${row.barcode}`, class: (row) => `` },
    { field: 'units', title: 'Unidades', cell: (row) => `${row.units}`, class: (row) => `` },
    { field: 'limitUnits', title: 'Límite Unidades', cell: (row) => `${row.limitUnits}`, class: (row) => `` },
    { field: 'size', title: 'Talla', cell: (row) => `${row.size}`, class: (row) => `` },
    { field: 'model', title: 'Modelo', cell: (row) => `${row.model}`, class: (row) => `` },

    { field: 'isStockEnabled', title: 'Stock habilitado', cell: (row) => row.isStockEnabled ? 'Sí' : 'No', class: (row) => `` },
    { field: 'serialNumber', title: 'Serial Number', cell: (row) => row.serialNumber ? 'Sí' : 'No', class: (row) => `` },
    { field: 'isTpv', title: 'Mostrar TPV', cell: (row) => row.isTpv ? 'Sí' : 'No', class: (row) => `` },

  ];
}

export class ConceptContactConst {
  public static headerTable = [
    { field: 'concept', title: 'Concepto', cell: (row) => `${row.concept}`, class: (row) => `` },
    { field: 'contact', title: 'Cliente', cell: (row) => `${row.contact}`, class: (row) => `` },
    { field: 'conceptCode', title: 'Código', cell: (row) => row.conceptCode ? `${row.conceptCode}` : '', class: (row) => `` },
    { field: 'price', title: 'Precio', cell: (row) => Utils.FormatMoney(row.price) + ' €', class: (row) => `` }
  ];
}

export class ControlStockConst {
  public static headerTable = [
    { field: 'description', title: 'Descripción', cell: (row) => row.description ? `${row.description}` : '', class: (row) => `` },
    { field: 'quantity', title: 'Cantidad', cell: (row) => row.quantity, class: (row) => `` }
  ];
}
